import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Route } from "react-router";
import { Flex, PaymentModal, WelcomeModal } from "/app/src/component";
import Header from "./Header";
import LeftPanel from "./LeftPanel";
import MainPanel from "./MainPanel";
import RightPanel from "./RightPanel";
import Modal from "./Modal";
import RespModal from "react-responsive-modal";

import { NotificationModel } from "/app/src/model/Notification";
import { Helmet } from "react-helmet";

import UserModel from "/app/src/model/User/model";
import UserSelector from "/app/src/model/User/selector";
import { CompanySelector } from "/app/src/model";
// socket
import {
  createSocket,
  destroySocket,
  listen as listenSocket
} from "/app/src/store/socket";

import Spinner from "/app/src/component/Spinner";
import { initialPromptPermission } from "/app/src/lib/WebNotification/notification";
import { HasShown } from "/app/src/lib";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.closeWelcomeModal = this.closeWelcomeModal.bind(this);
    const hasShownWelcome = HasShown.hasShown("welcomeModal");
    this.state = {
      showPaymentModal: false,
      showWelcomeModal: !hasShownWelcome
    };
  }

  closeWelcomeModal() {
    HasShown.setHasShown("welcomeModal");
    this.setState({ showWelcomeModal: false });
  }

  _resetTab() {
    document.title = "Jibber Dashboard";
    var favicon = document.querySelector('link[rel="shortcut icon"]');
    //Sometimes DOM not ready
    if (favicon) {
      favicon.setAttribute("type", "image/png");
      favicon.setAttribute("href", "/favicon.ico");
    }
  }

  componentDidMount() {
    if (this.props.userToken) {
      let url = this.props.apiUrl;
      createSocket(url);
      listenSocket(this.props.userId, this.props.userToken);
      this.props.dispatch(UserModel.getInitialData(true));
      this.props.dispatch(NotificationModel.read());
    }
    window.addEventListener("focus", this._resetTab);
    //Ask now, else it will prompt when notifications are needed.
    initialPromptPermission();
  }
  componentWillUnmount() {
    document.removeEventListener("focus", this._resetTab);
    destroySocket();
  }

  render() {
    const { paymentStatus } = this.props;
    if (this.props.fetchingData && this.props.fetchedData < 1) {
      return (
        <Flex
          width="100%"
          height="100%"
          hAlignContent="center"
          vAlignContent="center"
        >
          <Spinner />
        </Flex>
      );
    }
    const modalStyle = {
      modal: {
        padding: "0px",
        borderRadius: "20px",
        overflow: "hidden"
      }
    };

    const isBlockScreen = paymentStatus === "cancel";
    return (
      <Flex width="100%" height="100%" column>
        <Helmet>
          <meta charSet="utf-8" />
          <title> Jibber Dashboard </title>
          <link rel="shortcut icon" href="/favicon.ico" />
        </Helmet>
        <Flex basis="80px" width="100%">
          <Route component={Header} />
        </Flex>

        <Flex grow overflow="hidden">
          <Flex basis="25%">
            <Route component={LeftPanel} />
          </Flex>

          <Flex grow overflow="hidden">
            <Route component={MainPanel} />
          </Flex>

          <Route component={RightPanel} />
        </Flex>
        <Route component={Modal} />

        <RespModal
          styles={modalStyle}
          open={this.state.showWelcomeModal}
          onClose={this.closeWelcomeModal}
          showCloseIcon={true}
        >
          <WelcomeModal
            pricePlan={this.props.plan}
            onClose={this.closeWelcomeModal}
          />
        </RespModal>

        <RespModal
          styles={modalStyle}
          open={isBlockScreen}
          onClose={() => null}
          showCloseIcon={false}
        >
          <PaymentModal isBlockScreen={isBlockScreen} />
        </RespModal>

        <Route component={Modal} />
      </Flex>
    );
  }
}

function mapStateToProps(state) {
  return {
    plan: CompanySelector.getPaymentPlan(state),
    paymentStatus: CompanySelector.getPaymentStatus(state),
    apiUrl: state.getIn(["system", "api"]),
    userToken: UserSelector.getToken(state),
    userId: UserSelector.getId(state),
    fetchingData: state.getIn(["user", "initialData", "isFetching"], false),
    fetchedData: state.getIn(["user", "initialData", "isFetched"], true)
  };
}

export default withRouter(connect(mapStateToProps)(Dashboard));



// WEBPACK FOOTER //
// ./src/layout/Dashboard/index.js